// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"09dc916f","270":"20f4c3cd","404":"7b5ab58e","453":"635f5f07"}[chunkId] + ".chunk.js";
};